<template>
  <DialogWrapper
    class="ai-resume-parse-dialog"
    hideFooter
    :show.sync="showAIParseDialog"
    :closeOnClickModal="false"
    :isMobile="isMobile"
  >
    <div class="ai-parse-loading">
      <div class="start-label">{{ $t(`${i18nPrefix}.AI_PARSE_TASK_STATUS.START`) }}</div>
      <div class="ai-loading-container">
        <div v-rect-loading="true" class="icon"></div>
        <transition name="fade" mode="out-in">
          <div class="text is-pending" :key="currentLoadingTextIndex">
            <div class="label">{{ loadingTextOptions[currentLoadingTextIndex] }}</div>
          </div>
        </transition>
      </div>
    </div>
  </DialogWrapper>
</template>

<script>
import _ from 'lodash'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import { AI_PARSE_TASK_STATUS } from '@/constant/application'

export default {
  components: { DialogWrapper },
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate',
      showAIParseDialog: false,
      currentLoadingTextIndex: -1

    }
  },
  computed: {
    loadingTextOptions () {
      const list = _.map(AI_PARSE_TASK_STATUS, (val, key) => {
        if (key === 'START') {
          return
        }
        return this.$t(`${this.i18nPrefix}.AI_PARSE_TASK_STATUS.${val}`)
      })
      return _.filter(list)
    }
  },
  created () {

  },
  mounted () {

  },
  methods: {
    showNextLine () {
      if (this.currentLoadingTextIndex < this.loadingTextOptions.length - 1) {
        this.currentLoadingTextIndex++
      } else {
        clearInterval(this.loadingIntervalId)
      }
    },
    startAIParseLoading () {
      this.showAIParseDialog = true
      clearInterval(this.loadingIntervalId)
      this.currentLoadingTextIndex = -1
      this.showNextLine()
      this.loadingIntervalId = setInterval(() => {
        this.showNextLine()
      }, 5000)
    },
    closeAIParseDialog () {
      this.showAIParseDialog = false
      this.currentLoadingTextIndex = -1
      if (this.loadingIntervalId) {
        clearInterval(this.loadingIntervalId)
      }
    }
  },
  watch: {
    isShow: {
      handler (val) {
        if (val) {
          this.startAIParseLoading()
        } else {
          this.closeAIParseDialog()
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.ai-resume-parse-dialog {
  .ai-parse-loading {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;

    .start-label {
      white-space: normal;
      word-break: break-word;
      font-size: 14px;
    }

    .ai-loading-container {
      margin: auto auto 20px auto;
      padding: 0 120px;

      .icon {
        margin: 51px 0 51px 0;
        width: auto;
        height: 40px;
      }

      .text {
        display: flex;
        align-items: center;
        margin-bottom: 12px;

        .label {
          color: #b0b3b7;
          font-size: 12px;
          margin-left: 8px;
          flex: 1;
          white-space: normal;
          word-break: break-word;
        }
      }
    }
  }

  &.is-mobile {
    .ai-parse-loading {
      .ai-loading-container {
        padding: 0
      }
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
